// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tx-2";
export var chatLink = "_tx-0";
export var chatText = "_tx-1";